// @ts-nocheck
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import AddVocab from './components/AddVocab';
import App from './App';
import NotFound from './components/NotFound';
import QuestionVocab from './components/QuestionVocab';
import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

const routes = [
	{path: '/', redirect: '/question'},
	{path: '/question', component: QuestionVocab},
	{path: '/question/:word', component: QuestionVocab},
	{path: '/add', component: AddVocab},
	{path: '/notfound', component: NotFound},
	{path: '*', component: NotFound}
];

// TODO: USE ROUTE BASED DYNAMIC TRANSITIONS http://router.vuejs.org/en/advanced/transitions.html

const router = new Router({
	mode: 'history',
	routes: routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		else {
			return {
				x: 0,
				y: 0
			};
		}
	}
});

// return new Vue({
new Vue({
	router: router,
	el: '#app',
	template: '<App/>',
	components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js